export default "__VITE_ASSET__BmRD2QwD__"